import {
  Grid, Button, Box,
} from '@mui/material';
import i18n from './i18n';
import { getEnv, WA_NUMBER } from '../../api/env';
import '../../assests/css/cancelCreditStyle.css';

const whatsappCancelUrl = () => `https://wa.me/${getEnv(WA_NUMBER)}?text=${encodeURIComponent(i18n.formCancelWhatsappMessage)}`;

const FormCancelCredit = () => (
  <Grid container>
    <Grid item xs={1} md={3} />
    <Grid item xs={10} md={6}>
      <Box className="gridCard" sx={{ paddingTop: '10px', paddingBottom: '40px' }}>
        <Button
          variant="contained"
          className="ButtonMagenta cancelWhatsappButton"
          href={whatsappCancelUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          {i18n.formCancelRequestCancellation}
        </Button>
      </Box>
    </Grid>
    <Grid item xs={1} md={3} />
  </Grid>
);

export default FormCancelCredit;
